import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=d74848ae&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=d74848ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74848ae",
  null
  
)

export default component.exports